import React, { FC } from "react";

export type IconColor = "black" | "white" | "red";

interface Props {
  color: IconColor;
  size?: string;
}

export const EmbedIcon: FC<Props> = ({ color, size = "60px" }) => (
  <svg fill={color} height={size} width={size} viewBox="0 0 60 60">
    <path d="M30 0a30 30 0 1 0 30 30A30 30 0 0 0 30 0zm-5 40.43a2 2 0 0 1-2.77 0l-9-9a2 2 0 0 1 0-2.82l9-9A2 2 0 0 1 25 22.34L17.3 30l7.7 7.66a2 2 0 0 1 0 2.77zm21.88-9l-9 9a2 2 0 0 1-2.77-2.77L42.7 30l-7.65-7.66a2 2 0 0 1 2.77-2.77l9 9a2 2 0 0 1 0 2.82z" />{" "}
  </svg>
);

export const LinkIcon: FC<Props> = ({ color, size = "18px" }) => (
  <svg fill={color} height={size} width={size} viewBox="0 0 60 60">
    <path d="M30 0a30 30 0 1 0 30 30A30 30 0 0 0 30 0zm-1.6 38H22a8 8 0 0 1 0-16h6.4v3H22a5 5 0 0 0 0 10h6.4zm-4.8-6.4v-3.2h12.8v3.2zM38 38h-6.4v-3H38a5 5 0 0 0 0-10h-6.4v-3H38a8 8 0 0 1 0 16z" />
  </svg>
);
